// src/redux/store.ts
import { configureStore } from '@reduxjs/toolkit';
import { accountsApi } from '../api/account.api';
import { assetsApi } from '../api/asset.api';
import { authApi } from '../api/auth.api';
import { contractsApi } from '../api/contract.api';
import { filtersApi } from '../api/filters.api';
import { generalSearchApi } from '../api/generalSearch.api';
import { invoicesApi } from '../api/invoice.api';
import { usersApi } from '../api/user.api.ts';
import accountSlice from './slices/accountSlice';
import alertSlice from './slices/alertSlice';
import assetSlice from './slices/assetSlice';
import contractSlice from './slices/contractSlice';
import dashboardSearchSlice from './slices/dashboardSearchSlice';
import filterSlice from './slices/filterSlice';
import invoiceSlice from './slices/invoiceSlice.ts';
import loadingSlice from './slices/loadingSlice.ts';
import selectedGridRecordsSlice from './slices/selectedGridRecordsSlice';
import summaryGraphViewSlice from './slices/summaryGraphViewSlice.ts';
import uiSettingsSlice from './slices/uiSettingsSlice';
import { adminApi } from '../api/admin.api.ts';
import { csrRequestApi } from '../api/csrRequest.api.ts';
import udfUpdateSlice from './slices/udfUpdateSlice.ts';

export const store = configureStore({
	reducer: {
		[usersApi.reducerPath]: usersApi.reducer,
		contracts: contractSlice,
		[contractsApi.reducerPath]: contractsApi.reducer,
		assets: assetSlice,
		invoices: invoiceSlice,
		accounts: accountSlice,
		[assetsApi.reducerPath]: assetsApi.reducer,
		[accountsApi.reducerPath]: accountsApi.reducer,
		dashboardSearch: dashboardSearchSlice,
		uiSettings: uiSettingsSlice,
		[filtersApi.reducerPath]: filtersApi.reducer,
		filters: filterSlice,
		selectedGridRecords: selectedGridRecordsSlice,
		[invoicesApi.reducerPath]: invoicesApi.reducer,
		summaryGraphViewSlice: summaryGraphViewSlice,
		loading: loadingSlice,
		alert: alertSlice,
		[authApi.reducerPath]: authApi.reducer,
		[generalSearchApi.reducerPath]: generalSearchApi.reducer,
		[adminApi.reducerPath]: adminApi.reducer,
		[csrRequestApi.reducerPath]: csrRequestApi.reducer,
		udfUpdateSlice: udfUpdateSlice
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware()
			.concat(usersApi.middleware)
			.concat(contractsApi.middleware)
			.concat(assetsApi.middleware)
			.concat(filtersApi.middleware)
			.concat(accountsApi.middleware)
			.concat(invoicesApi.middleware)
			.concat(authApi.middleware)
			.concat(generalSearchApi.middleware)
			.concat(adminApi.middleware)
			.concat(csrRequestApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
